// extracted by mini-css-extract-plugin
export default {"medications-table":"MedicationsTable_medications-table_sGMEc"};